import { render, staticRenderFns } from "./qr-code.vue?vue&type=template&id=7be32c9e&lang=pug"
import script from "./qr-code.vue?vue&type=script&setup=true&lang=js"
export * from "./qr-code.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports